import {connect} from 'react-redux';

import {gettext, interpolate} from 'topmeteo/utils/i18n';

import {TypeSat} from 'topmeteo/general/constants';
import {getAvailableIndices} from 'topmeteo/general/selectors';
import {changeResolution} from 'topmeteo/general/actionCreators';
import {changeIndex} from 'topmeteo/base-image/actionCreators';

import {ResolutionOptGroup, isResolution, getResolution} from './ResolutionSelect';

const OptGroupLabel = gettext('Time (%(timezone)s)');

const TimeSelect = ({type, index, indices, timezone, onChange}) => (
    <div className="met-select-wrapper">
        <select className="met-select" value={index} onChange={onChange}>
            <optgroup label={interpolate(OptGroupLabel, {timezone})}>
                {indices.map(({key, title}) => <option key={key} value={key}>{title}</option>)}
            </optgroup>
            {type === TypeSat && <ResolutionOptGroup />}
        </select>
    </div>
);

const mapStateToProps = state => ({
    indices: getAvailableIndices(state),
    resolution: state.resolution,
    timezone: state.timezone,
    index: state.index,
});

const mapDispatchToProps = dispatch => ({
    onChange: ({target: {value}}) => {
        let payload = +value;
        let actionCreator = changeIndex;

        if (isResolution(value)) {
            payload = getResolution(value);
            actionCreator = changeResolution;
        }

        return dispatch(actionCreator(payload));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeSelect);
